export default __webpack_public_path__ + "static/media/email.6ac771e0.svg";